var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#222222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482-120q-75 0-140.83-28.5-65.84-28.5-115-77.33Q177-274.67 148.5-340.5T120-481.33q0-75 28.5-140.17 28.5-65.17 77.67-113.67 49.16-48.5 115-76.66Q407-840 482-840q80.67 0 152.83 35 72.17 35 123.84 97v-102h66.66v218.67H606V-658h106.67q-43-52.67-102.67-84t-128-31.33q-122.33 0-208.83 84.16-86.5 84.17-86.5 205.84 0 123.66 85.83 210.16t209.5 86.5q118.33 0 201.83-81.33 83.5-81.33 88.17-199.33h67.33q-5 145.66-108.5 246.5Q627.33-120 482-120Zm118.67-195.33-153.34-152V-682H514v187.33l134 132-47.33 47.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity_icon.eb4cba1d140339419a0e66e63d84935e.svg";
export { ForwardRef as ReactComponent };